import Button from "./Button";
import { marked } from 'marked';

export default function Contact({ content }) {
    const sisutekst = {__html: marked.parse(content.sisutekst)}
    return (
        <div id="Kontakt" className="contact">
            <div className="contact-text">
                <h3 className="contact-title">{content.pealkiri}</h3>
                <div className="contact-body" dangerouslySetInnerHTML={sisutekst}></div>
            </div>
            <div className="contact-buttons">
                <Button text={content.sekundaarne_nupp} href={'mailto:' + content.email} type={'btn btn-outline-primary'}/>
                <Button text={content.primaarne_nupp} href={'tel:' + content.tel_number} type={'btn btn-primary'} />
            </div>
        </div>
    )
}